var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGamepadCat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_839_189)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 15,
    fill: "#CAD6FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_189)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8276 32.9321V33.247C18.8276 33.2499 18.8623 33.6454 18.912 33.8414C19.4469 35.9471 21.4675 37.3095 23.5496 36.9393C24.9926 36.6828 26.0259 35.8492 26.6511 34.4826C26.7398 34.289 26.8214 34.092 26.903 33.895L26.903 33.895C27.0213 33.6094 27.1396 33.3237 27.2793 33.0482C27.484 32.6488 27.7781 32.3054 28.1373 32.0467C28.7283 31.6109 29.3814 31.4262 30.108 31.457C31.0237 31.4957 31.7565 31.8893 32.3387 32.6026C32.6401 32.9719 32.8151 33.4102 32.9897 33.8476C33.0365 33.9647 33.0832 34.0818 33.1323 34.1974C33.4809 35.018 33.957 35.7263 34.6935 36.2298C35.4367 36.7428 36.3202 36.9959 37.2135 36.9518C38.4996 36.905 39.5418 36.3601 40.3429 35.3336C40.8264 34.7141 41.1236 34.0066 41.1725 33.202V32.8871V32.4822C41.1725 32.3739 41.1632 32.2657 41.1538 32.1577C41.1503 32.1166 41.1468 32.0755 41.1437 32.0344C41.1397 31.9796 41.1372 31.9248 41.1347 31.8699C41.1307 31.7843 41.1268 31.6986 41.1171 31.6135C41.0384 30.9199 40.9397 30.2292 40.841 29.5385L40.8409 29.5379L40.8408 29.5374C40.8093 29.3166 40.7777 29.0958 40.7469 28.875C40.7047 28.5732 40.6658 28.2709 40.627 27.9686C40.537 27.2675 40.4469 26.5664 40.3148 25.8726C40.1516 25.0147 39.7037 24.2422 39.0482 23.6876C38.3926 23.133 37.5702 22.831 36.7222 22.8334C32.2426 22.8332 27.7631 22.8332 23.2836 22.8335C22.4022 22.836 21.5509 23.1639 20.8838 23.7577C20.2168 24.3516 19.7781 25.1721 19.6474 26.0706C19.5227 26.9381 19.4026 27.8063 19.287 28.6751C19.2356 29.0617 19.1692 29.4156 19.1031 29.7687C18.965 30.5053 18.8276 31.2383 18.8276 32.2573V32.8333V32.9321ZM23.6326 28.8312V30.3333H24.7842V28.8312H26.2759V27.6715H24.7842V26.1666H23.6326V27.6715H22.138V28.8312H23.6326ZM36.2069 26.1666H37.8621V27.8333H36.2069V26.1666ZM35.3794 28.6666H33.7242V30.3333H35.3794V28.6666Z",
    fill: "#2A2A2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_839_189",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_839_189"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 15,
    fill: "white",
    transform: "translate(18 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamepadCat);
export default __webpack_public_path__ + "static/media/Gamepad_cat.523ecd4fdc836c76c3e556842c815f92.svg";
export { ForwardRef as ReactComponent };